import { motion } from 'framer-motion';
import { Target, Users, Shield, TrendingUp } from 'lucide-react';

export default function Solution() {
    const features = [
        {
            icon: Target,
            title: 'Curated Challenges',
            description: 'Browse fun, safe dares from easy to expert',
            detail: 'Never wonder what to create again',
            gradient: 'from-primary-500 to-primary-600',
        },
        {
            icon: Users,
            title: 'Instant Community',
            description: 'See how others completed the same dare',
            detail: 'Join a global community of creators',
            gradient: 'from-secondary-500 to-secondary-600',
        },
        {
            icon: Shield,
            title: 'Safe & Fun',
            description: 'Every dare is pre-vetted for safety',
            detail: 'No dangerous stunts, just pure entertainment',
            gradient: 'from-green-500 to-emerald-500',
        },
        {
            icon: TrendingUp,
            title: 'Built-in Engagement',
            description: 'Completing dares = instant discovery',
            detail: 'Your creativity gets seen',
            gradient: 'from-primary-500 to-secondary-500',
        },
    ];

    return (
        <section className="py-20 gradient-bg">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-4">
                        DareUp Gives You the Challenge.
                        <br />
                        <span className="text-gradient">You Bring the Creativity.</span>
                    </h2>
                    <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                        A new way to create and share videos that's structured, safe, and seriously fun.
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
                    {features.map((feature, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            className="group bg-dark-800 border border-dark-700 rounded-2xl p-6 shadow-lg hover:shadow-xl hover:shadow-primary-500/10 transition-all duration-300 hover:-translate-y-1"
                        >
                            <div
                                className={`inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br ${feature.gradient} rounded-xl mb-4 shadow-lg`}
                            >
                                <feature.icon className="w-7 h-7 text-white" />
                            </div>
                            <h3 className="font-display text-lg font-bold text-white mb-2">{feature.title}</h3>
                            <p className="text-gray-400 text-sm mb-2">{feature.description}</p>
                            <p className="text-gray-500 text-xs italic">{feature.detail}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
